module.exports = __webpack_public_path__ + "static/media/image3.36ee0f4d.JPG";